///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.send_to_market = abcsetup.rfq.bid_requests.send_to_market || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.send_to_market.items_table = null;
abcsetup.rfq.bid_requests.send_to_market.non_items_table = null;
abcsetup.rfq.bid_requests.send_to_market.no_response_table = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.send_to_market = {
    init() {
        abcsetup.setTitle('RFQ Bid Review');

        // Challenger bids
        abcsetup.rfq.bid_requests.send_to_market.items_table = $('table#bid_review');

        // Add tooltips to the response datatable controls
        $('td.dtr-control').attr('title', 'Click to expand/collapse supplier response');

        $('#submit_bids_btn').on('click', () => {
            $('#bid_review_form [name=save_type]').val('close');
            this._on_submit();
        });

        $(document).on('click', '[data-toggle=lightbox]', () => abcsetup.alerts.hide());

        this._bind_no_incumbent_checkbox();

        // RFQ Event delete button clicked
        $(document).on('click', '.btn-reject', function () {
            var _this = $(this);

            abcsetup.alerts.prompt('Reject RFQ Bid', 'Please specify a reason to reject this bid back to the supplier:', function (resp) {
                if (resp[0] == true) {
                    abcsetup.rfq.bid_requests.send_to_market.rejectBidBackToSupplier(_this.data('id'), _this.data('org_id'), resp[1]);
                }
            }, true);

            return false;
        });

        $(document).on('click', '.btn-copy-previous-row', function () {
            const black_list = ['rfq_bid_status_id'];
            const this_row = $(this).closest('tr');
            const previous_row = this_row.prev('tr');

            previous_row.find(':input[name^="bids["]:visible').each(function () {
                const field_name = $(this).attr('name').replace(/(^.*\[|]$)/g, '');
                if (black_list.includes(field_name)) {
                    return;
                }

                this_row.find(`[name^="bids["][name$="[${field_name}]"]`).val($(this).val()).trigger('change', {revalidate: true});
            });
        });

        $(document).on('click', '.btn-bid-details', function () {
            abcsetup.alerts.show($(this).data('alert_title'), $(this).parent().find('.bid-details').html());
        });

        this._setup_conversion_elements();

        // Init the RFQ comments lib confirmation lib.
        abcsetup.rfq.comments.init();
    },


    /**
     * Submit the bid review form.
     *
     * @private
     */
    _on_submit({saveForLater = false, convertToSolicited = false} = {}) {
        const showBidsTable = () => $('#bids-toggle :radio[value=bids]').parents('.btn').trigger('click');

        let isValid = false;
        if (convertToSolicited) {
            fieldValidate.resetValidation($('#bid_review_form'));
            isValid = true;
        } else {
            isValid = true;
        }

        if (isValid) {
            showBidsTable();
            abcsetup.blockUI(true);
            $('#bid_review_form').trigger('submit');
        } else {
            // The sticky header on the challenger bids table can cover the field that's in error. Scrolling up a bit to prevent this.
            window.scrollBy(0, -100);
        }
    },

    _bind_no_incumbent_checkbox() {
        $(document).on('change', ':checkbox[name*=no_incumbent]', function () {
            if ($(this).prop('checked')) {
                // Clear selected incumbent, if any.
                $(this).parents('td').find('.select2-hidden-accessible').val(null).trigger('change');
            }
        });
    },

    _setup_conversion_elements() {
        const _this = this;
        const updateUIBasedOnConvertCheckboxes = () => {
            $('#convert-btn').attr('disabled', $('.convert-checkbox:checked').length === 0);

            $('.convert-checkbox').each(function () {
                const noIncumbentCheckbox = $(this).parents('tr').find('.no-incumbent-checkbox');
                if (!noIncumbentCheckbox) {
                    return;
                }

                noIncumbentCheckbox.attr('disabled', $(this).is(':checked'));
                if ($(this).is(':checked')) {
                    noIncumbentCheckbox.prop('checked', false).trigger('change', {revalidate: true});
                }
            });
        };

        // The convert item checkbox was clicked
        $(document).on('click', '.convert-checkbox', updateUIBasedOnConvertCheckboxes);

        // The convert item button was clicked
        $(document).on('click', '#convert-btn', function () {
            $('#bid_review_form [name=save_type]').val('convert_market');
            _this._on_submit({convertToSolicited: true});
        });

        updateUIBasedOnConvertCheckboxes();
    },
}
